import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 15000,
});

// Minutes EAST of UTC — used by backend to compute local days/weeks
export const tzOffset = () => -new Date().getTimezoneOffset();

export const createProfileApi = (payload) => api.post("/profiles", payload).then((r) => r.data);
export const getProfileApi = (id) => api.get(`/profiles/${id}`).then((r) => r.data);

// Phase 9: permanent server-side deletion of ALL data linked to a profile
export const deleteProfileApi = (id) => api.delete(`/profiles/${id}`).then((r) => r.data);
export const updateProfileApi = (id, payload) => api.put(`/profiles/${id}`, payload).then((r) => r.data);

export const createActivityApi = (payload) => api.post("/activities", payload).then((r) => r.data);
export const listActivitiesApi = (profileId, limit = 20) =>
  api.get("/activities", { params: { profile_id: profileId, limit } }).then((r) => r.data);
export const deleteActivityApi = (activityId, profileId) =>
  api.delete(`/activities/${activityId}`, { params: { profile_id: profileId } }).then((r) => r.data);

// ----- Stage 2.2: activity editing -----
export const getActivityApi = (activityId, profileId) =>
  api.get(`/activities/${activityId}`, { params: { profile_id: profileId } }).then((r) => r.data);
export const updateActivityApi = (activityId, profileId, payload) =>
  api.put(`/activities/${activityId}`, payload, { params: { profile_id: profileId } }).then((r) => r.data);

export const getStatsApi = (profileId) =>
  api.get(`/stats/${profileId}`, { params: { tz_offset: tzOffset() } }).then((r) => r.data);

// ----- Stage 2.1: Community -----
export const getFeedApi = (profileId, filterBy = "all", limit = 50) =>
  api
    .get("/feed", { params: { profile_id: profileId, filter_by: filterBy, limit } })
    .then((r) => r.data);

export const toggleKudosApi = (postId, profileId) =>
  api.post(`/posts/${postId}/kudos`, null, { params: { profile_id: profileId } }).then((r) => r.data);

export const toggleFollowApi = (followerId, followeeId) =>
  api
    .post("/follows/toggle", { follower_id: followerId, followee_id: followeeId })
    .then((r) => r.data);

export const getChallengesApi = (profileId) =>
  api
    .get("/challenges", { params: { profile_id: profileId, tz_offset: tzOffset() } })
    .then((r) => r.data);

export const toggleChallengeApi = (challengeKey, profileId) =>
  api
    .post(`/challenges/${challengeKey}/toggle`, null, { params: { profile_id: profileId } })
    .then((r) => r.data);

// ----- Phase 10: Google Play UGC compliance -----
export const createReportApi = (payload) => api.post("/reports", payload).then((r) => r.data);

export const listBlocksApi = (profileId) =>
  api.get("/blocks", { params: { profile_id: profileId } }).then((r) => r.data);

export const blockUserApi = (blockerId, blockedId) =>
  api.post("/blocks", { blocker_id: blockerId, blocked_id: blockedId }).then((r) => r.data);

export const unblockUserApi = (blockerId, blockedId) =>
  api
    .delete("/blocks", { params: { blocker_id: blockerId, blocked_id: blockedId } })
    .then((r) => r.data);

export const acceptUgcTermsApi = (profileId) =>
  api.post(`/profiles/${profileId}/accept-ugc-terms`).then((r) => r.data);

// ----- Stage 2.2: one-time challenge celebration -----
export const celebrateChallengeApi = (challengeKey, profileId) =>
  api
    .post(`/challenges/${challengeKey}/celebrate`, null, {
      params: { profile_id: profileId, tz_offset: tzOffset() },
    })
    .then((r) => r.data);
